<template>
  <div id="app">
    <div
      class="alert alert-warning alert-dismissible"
      role="alert"
      style="text-align: center;margin-bottom: 0;"
      id="alertMsg"
      v-if="showMsg"
    >
      <a
        href="https://www.pinnongjt.com"
        target="_blank"
        style="color: #F84831;font-size: 18px;"
        ><strong>重要通知：</strong>
        「品农商用车」新站点www.pinnongjt.com已经正式启用，请点击访问。</a
      >
    </div>
    <router-view v-if="showView" />
  </div>
</template>

<style lang="scss">
@import './assets/css/reset.css';
@import './assets/css/theme.scss';
</style>

<script>
export default {
  data() {
    return {
      showMsg: false,
      showView: true
    }
  },
  mounted() {
    var winUrl = window.location.host
    var winName = winUrl.split('.')
    if (winName[1] === 'pinganft') {
      this.showMsg = true
      this.showView = false
    } else {
      this.showMsg = false
      this.showView = true
    }
  }
}
</script>
